import axios from '../../axios/index.js'
import store from '../../../store/store.js'


export default {
   
    getAllClaims(sortBy, sortOrder, pageNumber, pageSize, isApprover) {
        return axios.get('/api/claims', { params : {
            sortBy: sortBy,
            sortOrder: sortOrder,
            pageNumber: pageNumber,
            pageSize: pageSize,
            isApprover: isApprover
        }})
    },
    getClaimsDetailsByClaimsId(claimsId) {
        return axios.get(`/api/claimsdetails/${claimsId}`)
    },
    
}